import * as React from 'react'
import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'

import FilterButton from '../Filters'
import { LeadFilters } from './LeadFilters'
import { selectLeadFilters } from '@user/store/lead/slice'
import {
  clearedFilters,
  defaultFilters,
  LeadFilterSet,
  orderByOptions,
} from '@user/store/lead/filters'
import { useSaveLeadFilters } from '@user/store/lead/hooks'
import { ILead } from '@user/store/lead/typings'
import { CardListViewMode } from '@sales-center/components'
import { validateLeadFilters } from './LeadFilters/utils'
import { useLocation } from 'react-router-dom'
export const LeadPageFilterButton: FC<{
  mode: CardListViewMode
  disabled: boolean
}> = ({ mode, disabled }) => {
  const { filterSet } = useSelector(selectLeadFilters)
  const saveLeadFilters = useSaveLeadFilters()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const importName = params.get('importNameFilter')
  const importId = params.get('importIdFilter')

  useEffect(() => {
    if (importName) {
      saveLeadFilters({
        ...defaultFilters,
        filters: {
          ...defaultFilters.filters,
          closed: {
            ...defaultFilters.filters.closed,
            value: 'empty',
          },
          importId: {
            ...defaultFilters.filters.importId,
            value: {
              mode: 'any',
              options: [{ value: importId, label: importName }],
            },
          },
        },
      })
      history.replaceState(null, '', `/#${location.pathname}`)
    }
  }, [importName])

  return (
    <FilterButton<ILead, LeadFilterSet>
      applyCallback={saveLeadFilters}
      clearedValues={clearedFilters}
      defaultValues={defaultFilters}
      filterComponent={LeadFilters}
      initialValues={filterSet}
      orderOptions={orderByOptions}
      hideOrderBy={mode === 'list'}
      disabled={disabled}
      validate={validateLeadFilters}
    />
  )
}

LeadPageFilterButton.displayName = 'LeadPageFilterButton'
